import { createAction, props } from '@ngrx/store';
import { WorkspaceItem, WorkspaceMoveRequest } from '@primatoo-ms-organization';


/**
 * ATTENZIONE....
 *
 * l'ATTACHMENT a differenza delle altre azioni ha SOLO Alcuni metodi e non va utilizzato per copiare ed incollare le azioni
 * @giovanni
 */
export const importAttachmentWithDialog = createAction('[Attachment] Import Attachment with dialog', props<{
  parentId: number
}>());
export const importAttachmentSuccess = createAction('[Attachment] Import Attachment Success', props<{
  parentId: number
}>());
export const importAttachmentFailed = createAction('[Attachment] Import Attachment Failed', props<{ error: any }>());

export const moveAttachment = createAction('[Attachment] Move Attachment', props<{
  id: number,
  workspaceMoveRequest: WorkspaceMoveRequest
}>());
export const moveAttachmentSuccess = createAction('[Attachment] Move Attachment Success', props<{
  item: WorkspaceItem
}>());
export const moveAttachmentFailed = createAction('[Attachment] Move Attachment Failed', props<{ error: any }>());

export const deleteAttachment = createAction('[Attachment] Delete Attachment', props<{ id: number }>());
export const deleteAttachmentSuccess = createAction('[Attachment] Delete Attachment Success');
export const deleteAttachmentFailed = createAction('[Attachment] Delete Attachment Failed', props<{ error: any }>());
